enum ResponsibleStatus {
  'INACTIVE',
  'ACTIVE',
}

export default ResponsibleStatus;
